import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AngularFireMessaging} from '@angular/fire/messaging';
import {NotificationsService} from '../api/notifications/notifications.service';
import {first} from 'rxjs/operators';
import {AppSettings} from '../helpers/app-settings';
import {ToastrService} from 'ngx-toastr';
import {NotificationPush} from '../api/notifications/notification-push-token.model';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  currentMessage = new BehaviorSubject(null);

  constructor(private angularFireMessaging: AngularFireMessaging,
              private notificationService: NotificationsService,
              private appSettings: AppSettings, private router: Router,
              private toastr: ToastrService) {
    // this.angularFireMessaging.messaging.subscribe(
    //   (_messaging) => {
    //     _messaging.onMessage = _messaging.onMessage.bind(_messaging);
    //     _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
    //   }
    // );
  }

  requestPermission(): void {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {

        if (token !== null) {

          this.appSettings.set('push-token', token);

          this.notificationService.addPushToken(token)
            .pipe(first())
            .subscribe(() => {
              this.appSettings.set('push-token-sent', 'true');
            });
        }
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }

  receiveMessage(): void {
    this.angularFireMessaging.messages.subscribe(
      (payload: NotificationPush) => {
        console.log('new message received. ', payload);
        this.currentMessage.next(payload);

        if (payload.data.action === 'REDIR') {
          location.href = payload.notification.click_action;
        }

        // Mostrar la notificacion
        this.toastr.info(payload.notification.body, payload.notification.title);
      });
  }
}
